import { Component, OnInit } from '@angular/core';
import { MentorService,HrmsService} from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-stfmenschedule',
  templateUrl: './stfmenschedule.component.html',
  styleUrls: ['./stfmenschedule.component.scss'],
   providers:[HrmsService,MentorService]
})
export class StfmenscheduleComponent implements OnInit {

  
  
      // books: Book[];
       memberdetails:any[]=[];
       classdetails:any[]=[];
       closeResult: string;
      
       student:boolean=true;
       staff:boolean=false;
       memberdash:any={};
       arrschh=[];
       arrschd=[];
       arrclass=[];
       arrstudent=[];
       selcls:any;
       selstu:any;
       objschh:any={};
       stfid:any;
       objschd:any={};
       status='Pending';
  
       modalOptions:NgbModalOptions;
       private modalRef: NgbModalRef;
       fserdt:any;
       fserdt4:any;
       classes=[];
       selclass:any;
       schdt:any;
    arrcourse: any;
    sections: any;
     fmodel:any={};
    fmodel1:any={};
    stualloted: any;
      completeDate: Date;
    localCompleteDate: string;
    arrstualloted: any=[];
     selstudent:any={};
       constructor(private http: HttpClient, private hservice: HrmsService,private mentservice: MentorService,private modalService: NgbModal) 
       {
  
        this.fmodel.emid=localStorage.getItem('usid');
      var d=new Date();
      this.fserdt=this.mentservice.getdatetoday();
      this.fserdt4=this.mentservice.getdatetoday();
      this.schdt=this.mentservice.getdatetoday();
  
      
        }
     
      
     
       private getDismissReason(reason: any): string {
         if (reason === ModalDismissReasons.ESC) {
           return 'by pressing ESC';
         } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
           return 'by clicking on a backdrop';
         } else {
           return `with: ${reason}`;
         }
       }
     
     
     
       ngOnInit(): void {
         this.getmentors();
       
        
       }
  

         getmentors() {
    this.hservice.selmentoringstaff()
        .subscribe(
        resultArray => {
            console.log('getmentors', resultArray);
            this.arrclass=resultArray;
            this.fmodel.emid=resultArray[0].emid;
            this.fmodel1.emid=resultArray[0].emid;
             this.getschedules('selschmenbyemid');
        },
        error => console.log("Error :: " + error)
      )}
    
   
  
  
       getschedules(oprtype) {
         debugger;
         this.mentservice.getmentschedules(oprtype,this.fmodel1.emid,this.fserdt4)
             .subscribe(
             resultArray => {
                 console.log('members-result', resultArray);
               
                 this.arrschh = resultArray;
               
                 
             },
             error => console.log("Error :: " + error)
             )
       }

       openinfo(content,obj)
{
  // this.getstudentdata('sel_nonalloted');
  this.objschd=obj;
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        
    });
}

  
     
     
     
      
     }
  